import { moduleFactory } from "@/factories/module";

import { askForUserFile } from "@/modules/file/askForUserFile";
import { uploadFile, makeUploadUrlParts } from "@/modules/file/upload";
import { convertEncodedFileContentToBlob } from "@/modules/file/blob";
import {
  downloadFileFromContent,
  downloadFileFromUrlDirectly,
  downloadFileFromUrl,
} from "@/modules/file/download";
import { checkIfFileCanBeUploaded, checkIfImageCanBeUploaded } from "@/modules/file/validation";
import { collectFileDropItems } from "@/modules/file/dropItems";
import { normalizeFilename } from "@/modules/file/normalizeFileName";
import { uploadAriaFileItem, uploadAriaFileItems } from "@/modules/file/ariaFileItems";
import { importFilesAsSession } from "@/modules/file/import";
export const fileModule = moduleFactory.create({
  upload: uploadFile,
  makeUploadUrlParts,
  uploadAriaFileItem,
  uploadAriaFileItems,
  downloadFileFromContent: downloadFileFromContent,
  downloadFileFromUrl: downloadFileFromUrl,
  downloadFileFromUrlDirectly: downloadFileFromUrlDirectly,
  convertEncodedFileContentToBlob: convertEncodedFileContentToBlob,
  checkIfFileCanBeUploaded: checkIfFileCanBeUploaded,
  checkIfImageCanBeUploaded: checkIfImageCanBeUploaded,
  collectFileDropItems,
  askForUserFile,
  normalizeFilename,
  importFilesAsSession,
});
